module.exports = __webpack_public_path__ + "img/bjgn.19cebe8e.png";